<script type="text/babel">
import HasLoadingState from 'dashboard-js/mixins/HasLoadingState'
import NavigationProvider from 'dashboard-js/providers/NavigationProvider'
import RestoreOnPageBack from 'dashboard-js/mixins/RestoreOnPageBack'

export default {
    mixins: [HasLoadingState, RestoreOnPageBack],

    props: [],

    data() {
        return {
            activeAmbassadorships: {},
            inactiveAmbassadorships: {},
        }
    },

    created() {
        this.onPageRestore(() => this.load(true))
        this.onPageVisit(() => {
            this.load()
        })
    },

    methods: {
        load(silently) {
            this.getAmbassadorships('active')
                .then(response => {
                    this.activeAmbassadorships = response.data.data
                })
                .then(this.saveState)
            this.getAmbassadorships('stopped')
                .then(response => {
                    this.inactiveAmbassadorships = response.data.data
                })
                .then(this.finishLoading(silently))
                .then(this.saveState)
        },

        getAmbassadorships(status) {
            return axios.get(route('api.ambassadorships') + '?filter[status]=' + status)
        },

        invitationDeclined() {
            NavigationProvider.go(route('influencer.ambassadorships'))
        },

        invitationAccepted() {
            NavigationProvider.reload()
        },
    },
}
</script>
